(() => {
  const STEP = 10;
  const MIN = 10;

  function normalize(n) {
    n = parseInt(String(n || ''), 10);

    if (isNaN(n) || n < MIN) {
      return MIN;
    }

    return Math.max(
      MIN,
      Math.round(n / STEP) * STEP
    );
  }

  function getStock(form) {
  // 1. Falls Bestand bereits direkt im Formular vorhanden ist
  const stockInput = form.querySelector('[data-qa10-stock]');

  if (stockInput) {
    const stock = parseInt(stockInput.value, 10);

    if (Number.isFinite(stock)) {
      return stock;
    }
  }

  // 2. Variante aus dem Quick-Buy-Formular holen
  const variantId = String(
    form.querySelector('input[name="id"]')?.value || ''
  );

  if (!variantId) {
    return null;
  }

  // 3. Bestand direkt aus den aktuell geladenen USF-Daten holen
  const items = window.usf?.search?.result?.items;

  if (!Array.isArray(items)) {
    return null;
  }

  for (const product of items) {
    if (!Array.isArray(product.variants)) {
      continue;
    }

    const variant = product.variants.find(
      v => String(v.id) === variantId
    );

    if (variant) {
      const stock = parseInt(variant.available, 10);

      return Number.isFinite(stock) ? stock : null;
    }
  }

  return null;
}

  function getMaxQuantity(form) {
    const stock = getStock(form);

    if (stock === null) {
      return null;
    }

    return Math.floor(stock / STEP) * STEP;
  }

  function toast(msg = 'Hinzugefügt') {
    let t = document.querySelector('.qa10-toast');

    if (!t) {
      t = document.createElement('div');
      t.className = 'qa10-toast';
      document.body.appendChild(t);
    }

    t.textContent = msg;
    t.classList.add('is-visible');

    clearTimeout(toast._t);

    toast._t = setTimeout(() => {
      t.classList.remove('is-visible');
    }, 1600);
  }

  function isBusy(el) {
    return el?.dataset?.qa10Busy === 'true';
  }

  function setBusy(el, state) {
    if (!el) return;

    el.dataset.qa10Busy = state ? 'true' : 'false';
  }


  async function ajaxAdd(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity
      })
    });

    if (!res.ok) {
      const err = await res.json().catch(() => null);

      console.error(
        'QA10 add failed:',
        err || res.statusText
      );

      toast('Fehler beim Hinzufügen');

      return false;
    }

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );

    return true;
  }

  function isCardAddForm(form) {
    if (!(form instanceof HTMLFormElement)) {
      return false;
    }

    const action = (
      form.getAttribute('action') || ''
    ).toLowerCase();

    if (!action.includes('/cart/add')) {
      return false;
    }

    const card = form.closest(
      'product-card, .product-card'
    );

    if (!card) {
      return false;
    }

    const id = form.querySelector(
      'input[name="id"]'
    )?.value;

    if (!id) {
      return false;
    }

    return true;
  }

  function setHiddenQty(form, qty) {
    let q = form.querySelector(
      'input[name="quantity"]'
    );

    if (!q) {
      q = document.createElement('input');
      q.type = 'hidden';
      q.name = 'quantity';
      form.appendChild(q);
    }

    q.value = String(qty);
  }

  function getQtyFromUIOrDefault(form) {
    const valEl = form.querySelector(
      '[data-qa10-val]'
    );

    if (valEl) {
      return normalize(valEl.textContent);
    }

    return MIN;
  }

  function markSoldOut(form) {
  const card = form.closest(
    'product-card, .product-card'
  );

  if (!card) {
    form.remove();
    return;
  }

  form.remove();

  const figure = card.querySelector(
    '.product-card__figure'
  );

  if (!figure) {
    return;
  }

  // Nicht doppelt einfügen
  if (
    figure.querySelector(
      '.badge--sold-out'
    )
  ) {
    card.classList.add(
      'qa10-is-sold-out'
    );
    return;
  }

  // Originale USF Badge-Liste suchen
  let badgeList = figure.querySelector(
    '.badge-list'
  );

  // Falls USF keine Badge-Liste gerendert hat,
  // dieselbe Struktur selbst erzeugen
  if (!badgeList) {
    badgeList =
      document.createElement('div');

    badgeList.className =
      'badge-list badge-list--vertical';

    figure.prepend(badgeList);
  }

  // Gleicher Badge wie bei regulär ausverkauften USF-Artikeln
  const badge =
    document.createElement(
      'sold-out-badge'
    );

  badge.className =
    'badge badge--sold-out';

  badge.textContent =
    'Ausverkauft';

  badgeList.appendChild(badge);

  card.classList.add(
    'qa10-is-sold-out'
  );
}

  function ensureUI(form) {
    if (!isCardAddForm(form)) {
      return;
    }

    const maxQuantity = getMaxQuantity(form);

    /*
     * Wenn ein Bestand über Liquid mitgegeben wird
     * und keine volle VE von 10 vorhanden ist:
     * Produktkarte als ausverkauft behandeln.
     */
    if (
      maxQuantity !== null &&
      maxQuantity < MIN
    ) {
      markSoldOut(form);
      return;
    }

    if (
      form.classList.contains('qa10-form') &&
      form.querySelector('.qa10-qty')
    ) {
      return;
    }

    const addBtn = form.querySelector(
      '.product-card__quick-add-button,' +
      ' button[type="submit"],' +
      ' button[name="add"]'
    );

    if (!addBtn) {
      return;
    }

    form.classList.add('qa10-form');

    if (!form.querySelector('.qa10-qty')) {
      const qtyWrap =
        document.createElement('div');

      qtyWrap.className = 'qa10-qty';

      qtyWrap.innerHTML = `
        <button
          type="button"
          class="qa10-qty__btn"
          data-qa10-minus
          aria-label="Weniger"
          disabled
        >−</button>

        <span
          class="qa10-qty__val"
          data-qa10-val
        >${MIN}</span>

        <button
          type="button"
          class="qa10-qty__btn"
          data-qa10-plus
          aria-label="Mehr"
        >+</button>
      `;

      addBtn.parentNode.insertBefore(
        qtyWrap,
        addBtn
      );

      setHiddenQty(form, MIN);
    }

    updateButtons(form);

    const onSuccess = form.querySelector(
      'input[name="on_success"]'
    );

    if (onSuccess) {
      onSuccess.value = '';
    }
  }

  function updateButtons(form) {
    const valEl = form.querySelector(
      '[data-qa10-val]'
    );

    const minus = form.querySelector(
      '[data-qa10-minus]'
    );

    const plus = form.querySelector(
      '[data-qa10-plus]'
    );

    if (!valEl) {
      return;
    }

    const current = normalize(
      valEl.textContent
    );

    const maxQuantity =
      getMaxQuantity(form);

    if (minus) {
      minus.disabled = current <= MIN;
    }

    if (plus) {
      if (maxQuantity !== null) {
        plus.disabled =
          current + STEP > maxQuantity;
      } else {
        plus.disabled = false;
      }
    }
  }

  function init(root = document) {
    const forms = root.querySelectorAll(
      'product-card form, .product-card form'
    );

    forms.forEach(ensureUI);
  }

  document.addEventListener(
    'click',
    (e) => {
      const minus =
        e.target.closest?.(
          '[data-qa10-minus]'
        );

      const plus =
        e.target.closest?.(
          '[data-qa10-plus]'
        );

      if (!minus && !plus) {
        return;
      }

      const form =
        e.target.closest?.('form');

      if (!isCardAddForm(form)) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const valEl = form.querySelector(
        '[data-qa10-val]'
      );

      if (!valEl) {
        return;
      }

      let current = normalize(
        valEl.textContent
      );

      const maxQuantity =
        getMaxQuantity(form);

      if (plus) {
        const next = current + STEP;

        if (
          maxQuantity !== null &&
          next > maxQuantity
        ) {
          return;
        }

        current = next;
      }

      if (minus) {
        current = Math.max(
          MIN,
          current - STEP
        );
      }

      valEl.textContent =
        String(current);

      setHiddenQty(form, current);

      updateButtons(form);
    },
    true
  );

  document.addEventListener(
    'click',
    async (e) => {
      const btn =
        e.target.closest?.(
          '.product-card__quick-add-button,' +
          ' form.qa10-form button[type="submit"],' +
          ' form.qa10-form button[name="add"]'
        );

      if (!btn) {
        return;
      }

      const form =
        btn.closest('form');

      if (!isCardAddForm(form)) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      ensureUI(form);

      /*
       * ensureUI kann das Formular entfernen,
       * wenn <10 Stück vorhanden sind.
       */
      if (!form.isConnected) {
        return;
      }

      if (isBusy(form)) {
        return;
      }

      const maxQuantity =
        getMaxQuantity(form);

      if (
        maxQuantity !== null &&
        maxQuantity < MIN
      ) {
        markSoldOut(form);
        return;
      }

      setBusy(form, true);

      const variantId =
        form.querySelector(
          'input[name="id"]'
        )?.value;

      if (!variantId) {
        setBusy(form, false);
        return;
      }

      const qty =
  getQtyFromUIOrDefault(form);

if (
  maxQuantity !== null &&
  qty > maxQuantity
) {
  toast(
    `Maximal ${maxQuantity} verfügbar`
  );

  setBusy(form, false);
  return;
}

setHiddenQty(
  form,
  qty
);

      btn.disabled = true;

      btn.setAttribute(
        'aria-busy',
        'true'
      );

      try {
        const ok = await ajaxAdd(
          variantId,
          qty
        );

        if (ok) {
          toast(
            `Hinzugefügt (${qty})`
          );
        }
      } finally {
        btn.disabled = false;

        btn.removeAttribute(
          'aria-busy'
        );

        setBusy(form, false);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;

      if (!isCardAddForm(form)) {
        return;
      }

      if (
        form.querySelector(
          '[data-qa10-val]'
        )
      ) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  const mo = new MutationObserver(
    (muts) => {
      for (const m of muts) {
        for (
          const node of m.addedNodes
        ) {
          if (!(node instanceof Element)) {
            continue;
          }

          if (
            node.matches?.(
              'product-card,' +
              ' .product-card,' +
              ' product-recommendations'
            ) ||
            node.querySelector?.(
              'product-card,' +
              ' .product-card,' +
              ' product-recommendations'
            )
          ) {
            init(node);
          }
        }
      }
    }
  );

  mo.observe(
    document.documentElement,
    {
      subtree: true,
      childList: true
    }
  );

  init();
})();